import { createSelector } from "@reduxjs/toolkit";

import { fastVersioningApi } from "@api/fast-versioning";
import { getIntegrationVars } from "../get-integration-vars";

const selectFastVarsSlice = fastVersioningApi.endpoints.getFastVars.select({});

export const getMappingObject = createSelector(
  getIntegrationVars,
  selectFastVarsSlice,
  (integrationVars = [], selectFastVarsSlice) => {
    const obj: { [key: string]: any } = {};
    const fsVars = selectFastVarsSlice?.data || [];

    for (const v of integrationVars) {
      obj[v.name] = v.mapping;
    }
    for (const mapping of fsVars) {
      obj[mapping.variable.name] = mapping.variable.mapping;
    }
    return obj;
  },
);
